import { useNavigate } from 'react-router-dom';
import { Badge, Box, Text, Tab, TabList, TabPanel, TabPanels, Tabs, Flex, Button } from '@chakra-ui/react';

import { LeftArrowIcon } from '@assets/icons/index';
import { useMassalStore } from '@pages/UploadMappingV2/hooks/state/useAddProductMassal';
import ProductSatuan from './ProductSatuan';
import ProductBundle from './ProductBundle';
import useMutateUploadMapping from '@pages/UploadMappingV2/hooks/mutate/useMutateUploadMapping';
import { useConfirmModal } from '@store/useConfirmModal';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import PostUploadModal from '@pages/UploadMappingV2/components/postUploadModal';
import { AppProvider } from '@pages/UploadMappingV2/context/AppContext';
import getUploadTutorial from '@hooks/tutorial/upload/getUpload';

export default function Mapping() {
    const navigate = useNavigate();
    const { set: setConfirmModal } = useConfirmModal();
    const { set: setFileUploadPopUp } = useFileUploadPopUp();
    const { data, pieces, bundles } = useMassalStore();
    const { validateUploadProdukMassal } = useMutateUploadMapping();
    const { data: uploadTutorial } = getUploadTutorial();

    const invalidBundlesCount = bundles.flatMap((b) => b.items).filter((item) => !item.barcode).length;
    const invalidPiecesCount = pieces.filter((p) => !p.barcode).length;

    const tabs = [
        {
            show: true,
            label: 'Product Satuan',
            count: invalidPiecesCount,
            component: <ProductSatuan />,
        },
        {
            show: true,
            label: 'Product Bundle',
            count: invalidBundlesCount,
            component: <ProductBundle />,
        },
    ].filter((t) => t.show);

    const handleSaveMapping = () => {
        const hasNullBarcode = pieces.some((row) => !row.barcode);
        const hasNullBarcodeBundle = bundles.some((bundle) => bundle.items.some((item) => !item.barcode));

        if (hasNullBarcode || hasNullBarcodeBundle) {
            return setConfirmModal({
                isOpen: true,
                title: 'Masih ada product belum dihubungkan',
                desc: 'Pastikan semua product telah dihubungkan dengan kode Paragon.',
                btnLabelYes: 'Mengerti',
                isShowBtnNo: false,
            });
        }

        const payload = {
            ...data,
            failed_data: {
                piece: pieces,
                bundle: bundles,
            },
        };

        validateUploadProdukMassal.mutate({ payload });
    };

    return (
        <Box bg="semantic.100" borderRadius="8px" p="20px">
            <Flex justifyContent="space-between" alignItems="center" mb="24px">
                <Flex alignItems="center" gap="16px">
                    <Box
                        cursor="pointer"
                        onClick={() => {
                            if (pieces.length > 0 || bundles.length > 0) {
                                setConfirmModal({
                                    isOpen: true,
                                    title: 'Apakah kamu ingin keluar?',
                                    desc: 'Proses menghubungkan product mu dengan kode product dari Paragon belum terselesaikan.',
                                    btnLabelYes: 'Ya, Keluar',
                                    isShowBtnNo: true,
                                    btnLabelNo: 'Kembali',
                                    onSubmit: () => {
                                        setFileUploadPopUp({
                                            isOpen: true,
                                            isFinishUploading: true,
                                            title: 'Upload Produk',
                                            isCanCancelUpload: true,
                                            isShowDownloadTemplate: false,
                                            helperText: {
                                                isShow: true,
                                                text: 'Temukan Panduan Mapping Disini!',
                                                isLink: true,
                                                url: uploadTutorial,
                                            },
                                            renderContent: (
                                                <AppProvider>
                                                    <PostUploadModal />
                                                </AppProvider>
                                            ),
                                        });
                                        navigate(-1);
                                    },
                                });
                            } else {
                                navigate(-1);
                            }
                        }}
                    >
                        <LeftArrowIcon />
                    </Box>

                    <Text fontSize="24px" fontWeight={600}>
                        Mapping Produk
                    </Text>
                </Flex>

                <Button px="32px" onClick={handleSaveMapping}>
                    Simpan Mapping
                </Button>
            </Flex>

            <Tabs>
                <TabList>
                    {tabs.map((t, i) => (
                        <Tab key={i}>
                            {t.label}
                            {t.count > 0 && (
                                <Badge rounded="full" color="semantic.100" bg="danger.500" ml="8px" p="4px 9px">
                                    {t.count}
                                </Badge>
                            )}
                        </Tab>
                    ))}
                </TabList>

                <TabPanels>
                    {tabs.map((t, i) => (
                        <TabPanel key={i} pb="0">
                            {t.component}
                        </TabPanel>
                    ))}
                </TabPanels>
            </Tabs>
        </Box>
    );
}
